const storageKey = `smart-payment-config-service-v1`;
const storage = typeof window === `undefined` ? undefined : window.sessionStorage;
export function writeToStorage(data, logger) {
    if (!storage) {
        return;
    }
    try {
        storage.setItem(storageKey, JSON.stringify(data));
    }
    catch (error) {
        logger.error(error);
    }
}
export function readFromStorage(logger) {
    if (!storage) {
        return {};
    }
    try {
        const stringifiedData = storage.getItem(storageKey);
        if (!stringifiedData) {
            return {};
        }
        return JSON.parse(stringifiedData);
    }
    catch (error) {
        logger.error(error);
        return {};
    }
}
//# sourceMappingURL=storage.js.map